import { AbstractCommand, StateService, CommandInterfaces, Command } from 'flux-core';
import { Injectable } from '@angular/core';

/**
 * This StateChangeCommand commnd is to set the HyperlinkEditState state
 * that is used to control the HyperinkEdit component
 */
@Injectable()
@Command()
export class EditHyperlink extends AbstractCommand {

    public static get dataDefinition(): {}  {
        return {
            open: true,
            origin: false,
            link: false,
            state: false,
            stateContext: false,
        };
    }

    public static get implements(): Array<CommandInterfaces> {
        return [ 'IStateChangeCommand' ];
    }

    constructor(
        protected state: StateService<any, any> ) {
        super()/* istanbul ignore next */;
    }

    public get states(): { [ stateId: string ]: any } {
        return {
            HyperlinkEditState: {
                open: this.data.open,
                origin: this.data.origin,
                link: this.data.link,
                state: this.data.state,
                stateContext: this.data.stateContext,
            },
        };
    }

    public execute(): boolean {
        return true;
    }
}

Object.defineProperty( EditHyperlink, 'name', {
    value: 'EditHyperlink',
});
